import { object } from '../../../schema';
import { CALL_API } from '../../../middleware/api';

const LOAD = 'browser/LOAD_OBJECT';
const LOAD_SUCESS = 'browser/LOAD_OBJECT_SUCESS';
const LOAD_FAIL = 'browser/LOAD_OBJECT_FAIL';

export const fetchObject = id => (dispatch, getState) => {
  const o = getState().entities.objects[id];
  if (!(o) || !o.products) {
    return dispatch({
      [CALL_API]: {
        types: [LOAD, LOAD_SUCESS, LOAD_FAIL],
        endpoint: `objects/${id}/`,
        method: 'GET',
        schema: object
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/objects/index.js